'use strict';

// Calculateur IFI
// https://havas.atlassian.net/browse/HAR-442

const BASE_URL = 'https://donner.fondation-arc.org/ifi-vaincrelecancer/~mon-don?int=ifi_interne';
const MAX_REDUCTION = 50000; // Montant maximmum de réduction d'impôt
const MAX_DON_AUTO = 66666.67;

// Calcul du don et de la réduction d'impôt en mode automatique
function calcAuto(ifi) {
    const don = Math.min(ifi / 0.75, MAX_DON_AUTO);
    const reduc = Math.min(don * 0.75, MAX_REDUCTION);
    const reste = Math.max(ifi - reduc, 0);
    return { don, reste };
}

// Calcul du don et de la réduction d'impôt en mode personnalisé
function calcPerso(ifi, donPerso) {
    const reduc = Math.min(donPerso * 0.75, MAX_REDUCTION);
    const reste = Math.max(ifi - reduc, 0);
    return { reduc, reste };
}

// Formatage des montants en euros
function formatAmount(value) {
    return Math.round(value).toLocaleString('fr-FR');
}

const IfiCalculator = {
    // Initialisation du composant
    init: function () {

        // Permet de trouver tous les blocs de calculateur IFI sur la page et d'y attacher les événements nécessaires
        // (ainsi on peut en avoir plusieurs sur la même page, on ne sait jamais...)
        const blocks = document.querySelectorAll('.f-ifiCalculator');
        if (!blocks.length) return;

        blocks.forEach(block => {
            // Éléments du DOM
            const mainInput    = block.querySelector('.js-ifi-main-input');
            const customInput  = block.querySelector('.js-ifi-custom-input');
            const autoDon      = block.querySelector('.js-ifi-auto-don');
            const autoReste    = block.querySelector('.js-ifi-auto-reste');
            const customReduc  = block.querySelector('.js-ifi-custom-reduc');
            const customReste  = block.querySelector('.js-ifi-custom-reste');
            // const autoBtn      = block.querySelector('.js-ifi-auto-btn');
            const customBtn    = block.querySelector('.js-ifi-custom-btn');

            if (!mainInput) return;

            // Fonction de mise à jour des calculs et de l'interface
            function update() {
                const ifi = parseFloat(mainInput.value) || 0;
                const donPerso = parseFloat(customInput ? customInput.value : 0) || 0;

                // Calcul du mode automatique
                const auto = calcAuto(ifi);
                if (autoDon)    autoDon.textContent    = formatAmount(auto.don);
                if (autoReste)  autoReste.textContent  = formatAmount(auto.reste);

                // Calcul du mode personnalisé
                const perso = calcPerso(ifi, donPerso);
                if (customReduc) customReduc.textContent = formatAmount(perso.reduc);
                if (customReste) customReste.textContent = formatAmount(perso.reste);

                // Mise à jour du lien de don personnalisé avec les paramètes d'url
                if (customBtn) {
                    const params = new URLSearchParams({
                        int: 'ifi_interne',
                        log: '0',
                        montant_autre_don: Math.round(donPerso),
                        montant_autre_reduction: Math.round(perso.reduc),
                        montant_autre_final: Math.round(perso.reste),
                    });
                    customBtn.href = BASE_URL.split('?')[0] + '?' + params.toString();
                }
            }

            mainInput.addEventListener('input', update);
            if (customInput) customInput.addEventListener('input', update);

            // Mise à jour des valeurs
            update();
        });
    },
};

export default IfiCalculator;
